import * as React from 'react';
import { UilAngleUp, UilAngleDown } from '@iconscout/react-unicons';
interface NumericInputProps {
    value: number;
    min: number;
    max: number;
    name: string;
    placeholder: string;
    autoFocus?: boolean;
    enableMaxLabel?: boolean;
    handleChange: (value) => void;
    handleDecrement: () => void;
    handleIncrement: () => void;
    setFocus?: (toggle: boolean) => void;
}

const NumericInput = (
    {
        value,
        min,
        max,
        name,
        placeholder,
        autoFocus,
        enableMaxLabel,
        handleChange,
        handleDecrement,
        handleIncrement,
        setFocus
    }: NumericInputProps,
    ref
) => {
    return (
        <div className="input--number" ref={ref} onClick={() => setFocus(true)}>
            {enableMaxLabel && max === value ? (
                <input disabled type="text" value={`MAX`} />
            ) : (
                <input
                    name={name}
                    type="number"
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => handleChange(e.target.value)}
                    autoFocus={autoFocus}
                    min={min}
                    max={max}
                />
            )}
            <span
                className="input--number--increment"
                onClick={() => handleIncrement()}
            >
                <UilAngleUp size={15} />
            </span>
            <span
                className="input--number--decrement"
                onClick={() => handleDecrement()}
            >
                <UilAngleDown size={15} />
            </span>
        </div>
    );
};

export default React.forwardRef(NumericInput);
